import React from 'react';
import styled from 'styled-components';
import { FiRefreshCw } from 'react-icons/fi';

interface HeaderProps {
  title: string;
  onRefresh: () => void;
}

const HeaderContainer = styled.header`
  background-color: var(--primary-color);
  color: white;
  padding: 16px 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 60px; /* Espaço para o ticker fixo */
  
  body.custom-theme & {
    background-color: var(--custom-background-color);
    color: var(--custom-font-color);
  }
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  
  body.custom-theme & {
    color: var(--custom-font-color);
    font-size: calc(var(--custom-font-size) * 1.5);
  }
`;

const RefreshButton = styled.button`
  background-color: transparent;
  color: white;
  border: 1px solid white;
  border-radius: 4px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  svg {
    font-size: 16px;
  }
`;

export const Header: React.FC<HeaderProps> = ({ title, onRefresh }) => {
  return (
    <HeaderContainer className="header">
      <HeaderContent>
        <Title>{title}</Title>
        <RefreshButton onClick={onRefresh}>
          <FiRefreshCw /> Atualizar
        </RefreshButton>
      </HeaderContent>
    </HeaderContainer>
  );
};